import React from 'react';
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import {KeyboardTimePicker, MuiPickersUtilsProvider,} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import LinearProgress from "@material-ui/core/LinearProgress";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Button} from "primereact/button";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import TabViewPresval from "../../../components/tabView";

const MaintenanceScheduleView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <div>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    {props.messagesGrowl}
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TitlePage title="Mantenimiento \ Horarios"/>
                        </Grid>
                        <Grid item xs={12}>
                            <TabViewPresval modelOptions={props.items}
                                            activeIndex={props.activeIndex}
                                            onSelect={props.handleTabChange}/>

                        </Grid>
                        <Grid item xs={12}>
                            {
                                props.activeIndex === 0 &&
                                <div className="p-grid">
                                    <div className="p-col-12 p-md-6 p-lg-6">
                                        <SubtitleLabel header="Horario de operación" isBold={true}/>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-6">
                                        {props.systemButtons}
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-3">
                                        <SubtitleLabel header="Inicio operación" isBold={true}/>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                margin="normal"
                                                name="startOperation"
                                                mask="__:__"
                                                ampm={false}
                                                keyboardIcon={<AccessTimeIcon/>}
                                                value={props.dataSchedule.startOperation}
                                                onChange={(event) => props.handleTimeChange("startOperation", event)}
                                                invalidDateMessage="Horario no válido. Formato 24 horas."/>
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-3">
                                        <SubtitleLabel header="Término operación" isBold={true}/>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                margin="normal"
                                                name="endOperation"
                                                mask="__:__"
                                                ampm={false}
                                                keyboardIcon={<AccessTimeIcon/>}
                                                value={props.dataSchedule.endOperation}
                                                onChange={(event) => props.handleTimeChange("endOperation", event)}
                                                invalidDateMessage="Horario no válido. Formato 24 horas."/>
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="p-col-12 p-md-12 p-lg-12">
                                        <SubtitleLabel header="Horario de Formalización de Préstamos" isBold={true}/>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-3">
                                        <SubtitleLabel header="Inicio formalización" isBold={true}/>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                margin="normal"
                                                name="startFormalization"
                                                mask="__:__"
                                                ampm={false}
                                                keyboardIcon={<AccessTimeIcon/>}
                                                value={props.dataSchedule.startFormalization}
                                                onChange={(event) => props.handleTimeChange("startFormalization", event)}
                                                invalidDateMessage="Horario no válido. Formato 24 horas."/>
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-3">
                                        <SubtitleLabel header="Termino formalización" isBold={true}/>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                margin="normal"
                                                name="endFormalization"
                                                mask="__:__"
                                                ampm={false}
                                                keyboardIcon={<AccessTimeIcon/>}
                                                value={props.dataSchedule.endFormalization}
                                                onChange={(event) => props.handleTimeChange("endFormalization", event)}
                                                invalidDateMessage="Horario no válido. Formato 24 horas."/>
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="p-col-12 p-md-12 p-lg-12">
                                        <SubtitleLabel header="Horario de Tablero de control" isBold={true}/>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-3">
                                        <SubtitleLabel header="Prestamista" isBold={true}/>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                margin="normal"
                                                name="timeControlPanelPtm"
                                                mask="__:__"
                                                ampm={false}
                                                keyboardIcon={<AccessTimeIcon/>}
                                                value={props.dataSchedule.timeControlPanelPtm}
                                                onChange={(event) => props.handleTimeChange("timeControlPanelPtm", event)}
                                                invalidDateMessage="Horario no válido. Formato 24 horas."/>
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-3">
                                        <SubtitleLabel header="Prestatario" isBold={true}/>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                margin="normal"
                                                name="timeControlPanelPtt"
                                                mask="__:__"
                                                ampm={false}
                                                keyboardIcon={<AccessTimeIcon/>}
                                                value={props.dataSchedule.timeControlPanelPtt}
                                                onChange={(event) => props.handleTimeChange("timeControlPanelPtt", event)}
                                                invalidDateMessage="Horario no válido. Formato 24 horas."/>
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-3">
                                        <SubtitleLabel header="Fideicomiso" isBold={true}/>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                margin="normal"
                                                name="timeControlPanelFid"
                                                mask="__:__"
                                                ampm={false}
                                                keyboardIcon={<AccessTimeIcon/>}
                                                value={props.dataSchedule.timeControlPanelFid}
                                                onChange={(event) => props.handleTimeChange("timeControlPanelFid", event)}
                                                invalidDateMessage="Horario no válido. Formato 24 horas."/>
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-3">
                                        <SubtitleLabel header="Liquidaciones" isBold={true}/>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                margin="normal"
                                                name="timeControlPanelLiq"
                                                mask="__:__"
                                                ampm={false}
                                                keyboardIcon={<AccessTimeIcon/>}
                                                value={props.dataSchedule.timeControlPanelLiq}
                                                onChange={(event) => props.handleTimeChange("timeControlPanelLiq", event)}
                                                invalidDateMessage="Horario no válido. Formato 24 horas."/>
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-3">
                                        <SubtitleLabel header="Indeval" isBold={true}/>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                margin="normal"
                                                name="timeControlPanelIndeval"
                                                mask="__:__"
                                                ampm={false}
                                                keyboardIcon={<AccessTimeIcon/>}
                                                value={props.dataSchedule.timeControlPanelIndeval}
                                                onChange={(event) => props.handleTimeChange("timeControlPanelIndeval", event)}
                                                invalidDateMessage="Horario no válido. Formato 24 horas."/>
                                        </MuiPickersUtilsProvider>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-3">
                                        <SubtitleLabel header="GSS" isBold={true}/>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <KeyboardTimePicker
                                                margin="normal"
                                                name="timeControlPanelGSS"
                                                mask="__:__"
                                                ampm={false}
                                                keyboardIcon={<AccessTimeIcon/>}
                                                value={props.dataSchedule.timeControlPanelGSS}
                                                onChange={(event) => props.handleTimeChange("timeControlPanelGSS", event)}
                                                invalidDateMessage="Horario no válido. Formato 24 horas."/>
                                        </MuiPickersUtilsProvider>
                                    </div>
                                </div>
                            }
                            {
                                props.activeIndex === 1 &&
                                <div className="p-grid">
                                    <div className="p-col-12 p-md-6 p-lg-8">
                                        <SubtitleLabel header="Horario por instituciones" isBold={true}/>
                                    </div>
                                    <div className="p-col-12 p-md-6 p-lg-4">
                                        <div style={{textAlign: 'right'}}>
                                            <Button type="button" iconPos="left" label="Agregar"
                                                    style={{marginRight: '.5em'}}
                                                    onClick={() =>
                                                        (props.redirectModifyInstitutionSchedule("new"))}
                                                    className="p-button-secondary"/>
                                        </div>
                                    </div>
                                    <div className="p-col-12">
                                        <DataTable value={props.dataInstitutionsSchedule}
                                                   responsive={true}
                                                   selectionMode="single"
                                                   onSelectionChange={props.handleSelectInstitution}
                                                   resizableColumns={true}
                                                   columnResizeMode={"fit"}>
                                            <Column field="nomCorto" header="Institución"
                                                    style={{textAlign: 'left'}}
                                                    sortable={true}/>
                                            <Column field="horaFinal" header="Hora final"
                                                    style={{textAlign: 'left'}}
                                                    body={(rowData) =>
                                                        (rowData['horaFinal']).substring(0, 5)}
                                                    sortable={true}/>
                                            <Column field="activo" header="Estatus"
                                                    style={{textAlign: 'left'}}
                                                    body={(rowData) =>
                                                        rowData['activo'] === 1 ? "Activo" : "Inactivo"}
                                                    sortable={true}/>
                                            <Column header="Acciones"
                                                    body={props.maintenanceScheduleActionTemplate}
                                                    style={{textAlign: 'right', width: '8em'}}/>
                                        </DataTable>
                                        {props.confirmationMsg}
                                    </div>
                                </div>
                            }
                        </Grid>
                    </Grid>
                </Paper>
            </div>
        </React.Fragment>
    )
};

export default /*withStyles(styles)*/(MaintenanceScheduleView);
